import React from 'react';
import styled from 'styled-components/native';
import StudyJourneyChart, {
  StudyJourneyChartProps
} from '../../components/StudyJourneyChart';
import { log } from '../../tools/LogHelper';

const StyledContainerView = styled.View`
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

const mockData: StudyJourneyChartProps = {
  title: 'Chill Pill Study Journey',
  data: [
    { title: 'Sign Up', description: 'Acceptance into study', dayCount: 7 },
    { title: 'Baseline', description: '1 week routine', dayCount: 7 },
    { title: 'Baseline', description: '1 week routine', dayCount: 7 },
    { title: 'On Intervention', description: '2 weeks with CBD', dayCount: 14 },
    {
      title: 'Off Intervention',
      description: '2 weeks without CBD',
      dayCount: 14
    },
    {
      title: 'Off Intervention',
      description: '2 weeks without CBD',
      dayCount: 14
    },
    { title: 'Baseline', description: '1 week routine', dayCount: 7 },
    { title: 'Baseline', description: '1 week routine', dayCount: 7 },
    { title: 'Baseline', description: '1 week routine', dayCount: 13 }
  ],
  currentDay: 21
};

// const mockData: StudyJourneyChartProps = {
//   title: 'Chill Pill Study Journey',
//   data: [
//     { title: 'Sign Up', description: 'Acceptance into study', dayCount: 7 },
//     { title: 'Baseline', description: '1 week routine', dayCount: 7 },
//     { title: 'On Intervention', description: '2 weeks with CBD', dayCount: 14 },
//     {
//       title: 'Off Intervention',
//       description: '2 weeks without CBD',
//       dayCount: 14
//     }
//   ],
//   currentDay: 21
// };

const StudyJourneyChartScreen: React.FC = () => {
  return (
    <StyledContainerView>
      <StudyJourneyChart
        data={mockData.data}
        title={mockData.title}
        currentDay={mockData.currentDay}
        onLearnMore={() => {
          log('Clicked Learn More');
        }}
      />
    </StyledContainerView>
  );
};
export default StudyJourneyChartScreen;
